const isOpen = ({isOpen}) => isOpen
const isHeaderFix = ({isHeaderFix}) => isHeaderFix
const product = ({ product }) => product
const productList = ({ product }) => product.productList
const tag = ({tag}) => tag
const tagList = ({tag}) => tag.tagList


export default {
  isOpen,
  isHeaderFix,
  product,
  productList,
  tag,
  tagList
}
